/*
 * Frank!y ingrediënten in gewone taal — gedrag voor snippets/frankly-ingredienten.liquid.
 * Geladen door die snippet (defer), zonder afhankelijkheden.
 *
 * 1. Herkennen: elke alinea in [data-frankly-ingr] die een ingrediëntenlijst is
 *    (namen met komma's ertussen, waarvan we er minstens vier van de vijf kennen).
 *    Bij een set zijn dat er twee. Andere alinea's (hoeveel, wanneer, hoe) blijven
 *    zoals ze zijn.
 * 2. Bouwen: vóór de alinea komt een schakelaar met twee standen. 'INCI'
 *    (standaard) toont de alinea zelf, ongewijzigd, met eronder een knop naar de
 *    gewone taal; 'Frank gezegd' toont de stoffen per groep, met hun gewone naam.
 * 3. Uitleg: eerst waarom de stof erin zit, dan wat het is en hoe hij op het
 *    etiket heet. Op een aanraakscherm klapt de uitleg onder de groep open en
 *    dicht met een tik. Met een muis zweeft hij onder het ingrediënt zolang de
 *    muis erop staat of het de focus heeft; Escape sluit hem.
 * 4. Meetpunten, alleen met toestemming voor analytics (zie frankly-pdp.js):
 *    frankly_pdp_ingr_uitleg { ingredient } en frankly_pdp_ingr_weergave
 *    { stand, via } (via 'schakelaar' of 'knop' onder de INCI-lijst), elk
 *    hoogstens één keer per waarde per paginaweergave.
 */
(function () {
  'use strict';

  // Dawns quick-add voert de scripts in de product-info opnieuw uit. Eén keer per
  // pagina is genoeg, net als in frankly-pdp.js.
  if (window.franklyIngrGeladen) return;
  window.franklyIngrGeladen = true;

  // ---------- meetpunten ----------

  // Zelfde regel als in frankly-pdp.js: is de stand van de toestemming nog niet
  // bekend, dan gaat er niets weg. Geeft true terug als het event echt is verstuurd.
  function meet(naam, data) {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (!p || typeof p.analyticsProcessingAllowed !== 'function') return false;
      if (p.analyticsProcessingAllowed() !== true) return false;
      if (window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(naam, data);
        return true;
      }
    } catch (err) {
      // Een meetpunt mag de pagina nooit ophouden.
    }
    return false;
  }

  // We willen weten welke ingrediënten vragen oproepen, niet hoe vaak iemand
  // dezelfde aantikt. Pas afvinken na een echte verzending.
  var gemeten = {};
  function meetEens(naam, data, sleutel) {
    if (gemeten[sleutel]) return;
    if (meet(naam, data)) gemeten[sleutel] = true;
  }

  // ---------- herkennen ----------

  // 'Alcohol Denat.' staat met een punt op het etiket; in de lijst zonder.
  function sleutelVan(naam) {
    return naam.replace(/\s+/g, ' ').replace(/^ | $/g, '').replace(/\.$/, '').toLowerCase();
  }

  // Een tekst uit de lijst, of de gedeelde zin waar hij met '@' naar verwijst.
  function zin(tekst, lijst) {
    if (!tekst) return '';
    return tekst.charAt(0) === '@' ? lijst.zinnen[tekst.slice(1)] || '' : tekst;
  }

  // Geeft de stoffen van een alinea in de volgorde van het etiket, of null als de
  // alinea geen ingrediëntenlijst is die we goed genoeg kennen.
  function lees(alinea, lijst) {
    if (alinea.children.length) return null;
    var namen = alinea.textContent.split(',');
    if (namen.length < 5) return null;
    var bekend = 0;
    var stoffen = namen.map(function (naam) {
      var etiket = naam.replace(/\s+/g, ' ').replace(/^ | $/g, '');
      var gevonden = lijst.stoffen[sleutelVan(naam)];
      if (!gevonden) return { etiket: etiket, naam: etiket, groep: 'overig', waarom: '', wat: '' };
      bekend += 1;
      return {
        etiket: etiket,
        naam: gevonden[0],
        groep: gevonden[1],
        waarom: zin(gevonden[2], lijst),
        wat: zin(gevonden[3], lijst)
      };
    });
    return bekend / stoffen.length >= 0.8 ? stoffen : null;
  }

  // ---------- bouwen ----------

  function maak(tag, klasse, tekst) {
    var el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (tekst) el.textContent = tekst;
    return el;
  }

  function bouw(alinea, stoffen, lijst, zweef, nr) {
    var tekst = lijst.tekst;
    var blok = maak('div', 'frankly-ingr');
    alinea.parentNode.insertBefore(blok, alinea);

    // De schakelaar. Twee knoppen met aria-pressed: er is altijd precies één stand aan.
    var schakel = maak('div', 'frankly-ingr__schakel');
    schakel.setAttribute('role', 'group');
    schakel.setAttribute('aria-label', tekst.weergave);
    var knoppen = ['inci', 'frank'].map(function (stand) {
      var knop = maak('button', 'frankly-ingr__stand', tekst[stand]);
      knop.type = 'button';
      knop.setAttribute('data-stand', stand);
      knop.setAttribute('aria-pressed', stand === 'inci' ? 'true' : 'false');
      schakel.appendChild(knop);
      return knop;
    });
    blok.appendChild(schakel);

    // Eén regel onder de schakelaar die zegt wat je ziet. Bij INCI legt hij het
    // woord INCI uit; bij 'Frank gezegd' dat je een ingrediënt kunt kiezen.
    var hint = maak('p', 'frankly-ingr__hint', tekst.hint_inci);
    blok.appendChild(hint);

    // De groepen, in de volgorde van de lijst; wat we niet kennen sluit de rij.
    var frank = maak('div', 'frankly-ingr__frank');
    var uitlegId = 'frankly-ingr-uitleg-' + nr;
    var teller = 0;
    lijst.groepen.concat([['overig', tekst.overig]]).forEach(function (groep) {
      var leden = stoffen.filter(function (stof) {
        return stof.groep === groep[0];
      });
      if (!leden.length) return;
      var vak = maak('div', 'frankly-ingr__groep');
      var hoofd = maak('div', 'frankly-ingr__groephoofd');
      hoofd.appendChild(maak('h4', 'frankly-ingr__groepkop', groep[1]));
      if (groep[2]) hoofd.appendChild(maak('p', 'frankly-ingr__noot', groep[2]));
      vak.appendChild(hoofd);
      var rij = maak('ul', 'frankly-ingr__pillen');
      leden.forEach(function (stof) {
        var item = maak('li');
        var pil;
        if (stof.waarom) {
          pil = maak('button', 'frankly-ingr__pil', stof.naam);
          pil.type = 'button';
          pil.setAttribute('aria-expanded', 'false');
          pil.setAttribute('aria-controls', uitlegId);
          pil.setAttribute('data-stof', stoffen.indexOf(stof));
        } else {
          pil = maak('span', 'frankly-ingr__pil frankly-ingr__pil--vast', stof.naam);
        }
        pil.style.setProperty('--i', teller++);
        item.appendChild(pil);
        rij.appendChild(item);
      });
      vak.appendChild(rij);
      frank.appendChild(vak);
    });
    if (tekst.bron) frank.appendChild(maak('p', 'frankly-ingr__bron', tekst.bron));
    frank.hidden = true;
    blok.appendChild(frank);

    // Eén uitlegvak per blok; het verhuist naar de groep van het gekozen ingrediënt.
    var uitleg = maak('div', 'frankly-ingr__uitleg');
    uitleg.id = uitlegId;
    uitleg.hidden = true;
    var uitlegNaam = maak('p', 'frankly-ingr__naam');
    var uitlegWaarom = maak('p', 'frankly-ingr__waarom');
    var uitlegWat = maak('p', 'frankly-ingr__wat');
    var uitlegEtiket = maak('p', 'frankly-ingr__etiket');
    uitleg.appendChild(uitlegNaam);
    uitleg.appendChild(uitlegWaarom);
    uitleg.appendChild(uitlegWat);
    uitleg.appendChild(uitlegEtiket);
    blok.appendChild(uitleg);

    // De focus blijft op het ingrediënt; een schermlezer hoort de uitleg hierdoor toch.
    var live = maak('span', 'visually-hidden');
    live.setAttribute('aria-live', 'polite');
    blok.appendChild(live);

    // De alinea van het etiket (INCI) is de eerste stand. Eronder een knop naar de
    // gewone taal, precies waar iemand die de namen niet kan lezen uitkomt. Zo
    // hoeft niemand te weten dat 'Frank gezegd' een woordgrap op 'frankly' is.
    alinea.classList.add('frankly-ingr__lijst');
    blok.appendChild(alinea);
    var naar = maak('button', 'frankly-ingr__naar', tekst.naar_frank);
    naar.type = 'button';
    blok.appendChild(naar);

    // ---------- uitleg ----------

    var actief = null;

    // Met een muis: onder het ingrediënt, binnen de breedte van de groep. Op een
    // aanraakscherm staat het vak gewoon in de lijst en regelt de CSS de rest.
    function plaats() {
      if (!actief || !zweef.matches) {
        uitleg.style.left = '';
        uitleg.style.top = '';
        return;
      }
      var ruimte = uitleg.parentNode.clientWidth - uitleg.offsetWidth;
      uitleg.style.left = Math.max(0, Math.min(actief.offsetLeft, ruimte)) + 'px';
      uitleg.style.top = actief.offsetTop + actief.offsetHeight + 6 + 'px';
    }

    function sluit() {
      if (!actief) return;
      actief.setAttribute('aria-expanded', 'false');
      actief = null;
      uitleg.hidden = true;
      live.textContent = '';
    }

    function open(pil) {
      if (actief === pil) return;
      sluit();
      var stof = stoffen[Number(pil.getAttribute('data-stof'))];
      actief = pil;
      pil.setAttribute('aria-expanded', 'true');
      uitlegNaam.textContent = stof.naam;
      uitlegWaarom.textContent = stof.waarom;
      uitlegWat.textContent = stof.wat ? tekst.wat + ' ' + stof.wat.charAt(0).toLowerCase() + stof.wat.slice(1) : '';
      uitlegWat.hidden = !stof.wat;
      uitlegEtiket.textContent = tekst.op_etiket + ' ' + stof.etiket;
      pil.closest('.frankly-ingr__groep').appendChild(uitleg);
      uitleg.hidden = false;
      plaats();
      live.textContent = stof.naam + '. ' + stof.waarom;
      if (!zweef.matches) {
        // De sticky koopbalk zet scroll-padding op de pagina (frankly-pdp.js), dus
        // 'nearest' schuift de uitleg tot boven de balk, en alleen als het nodig is.
        var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        uitleg.scrollIntoView({ behavior: rustig ? 'auto' : 'smooth', block: 'nearest' });
      }
      meetEens('frankly_pdp_ingr_uitleg', { ingredient: stof.etiket }, 'uitleg:' + stof.etiket);
    }

    function pilVan(event) {
      var doel = event.target && event.target.closest ? event.target.closest('button.frankly-ingr__pil') : null;
      return doel && frank.contains(doel) ? doel : null;
    }

    frank.addEventListener('click', function (event) {
      var pil = pilVan(event);
      if (!pil) return;
      // Met een muis is het vak al open door de hover; een klik mag het dan niet sluiten.
      if (!zweef.matches && actief === pil) sluit();
      else open(pil);
    });
    frank.addEventListener('mouseover', function (event) {
      var pil = zweef.matches ? pilVan(event) : null;
      if (pil) open(pil);
    });
    frank.addEventListener('mouseout', function (event) {
      var pil = zweef.matches ? pilVan(event) : null;
      if (pil && pil === actief && !pil.contains(event.relatedTarget)) sluit();
    });
    frank.addEventListener('focusin', function (event) {
      var pil = zweef.matches ? pilVan(event) : null;
      if (pil) open(pil);
    });
    frank.addEventListener('focusout', function (event) {
      var pil = zweef.matches ? pilVan(event) : null;
      if (pil && pil === actief) sluit();
    });
    frank.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') sluit();
    });
    window.addEventListener('resize', plaats);

    function zetZweef() {
      sluit();
      blok.classList.toggle('frankly-ingr--zweef', zweef.matches);
    }
    zetZweef();
    if (typeof zweef.addEventListener === 'function') {
      zweef.addEventListener('change', zetZweef);
    } else if (typeof zweef.addListener === 'function') {
      zweef.addListener(zetZweef);
    }

    // ---------- schakelaar ----------

    var wisselKlaar = 0;
    function zetStand(stand, via) {
      knoppen.forEach(function (k) {
        k.setAttribute('aria-pressed', k.getAttribute('data-stand') === stand ? 'true' : 'false');
      });
      sluit();
      frank.hidden = stand !== 'frank';
      alinea.hidden = naar.hidden = stand === 'frank';
      hint.textContent = stand === 'frank' ? tekst.hint_frank : tekst.hint_inci;
      // De klasse start de animatie waarmee de nieuwe stand binnenkomt. Eerst weg
      // en na een herberekening terug, zodat hij bij elke wissel opnieuw speelt.
      // Daarna weer weg: anders speelt hij ook als het tabblad opnieuw opent.
      clearTimeout(wisselKlaar);
      blok.classList.remove('is-gewisseld');
      void blok.offsetWidth;
      blok.classList.add('is-gewisseld');
      wisselKlaar = setTimeout(function () {
        blok.classList.remove('is-gewisseld');
      }, 1000);
      meetEens('frankly_pdp_ingr_weergave', { stand: stand, via: via }, 'stand:' + stand + ':' + via);
    }

    schakel.addEventListener('click', function (event) {
      var knop = event.target && event.target.closest ? event.target.closest('.frankly-ingr__stand') : null;
      if (!knop || knop.getAttribute('aria-pressed') === 'true') return;
      zetStand(knop.getAttribute('data-stand'), 'schakelaar');
    });

    // De knop verdwijnt na de klik. De focus gaat naar 'Frank gezegd' in de
    // schakelaar; dat schuift de pagina terug naar het begin van de lijst, die
    // nu veel langer is dan de alinea waar de knop onder stond.
    naar.addEventListener('click', function () {
      zetStand('frank', 'knop');
      knoppen[1].focus();
    });
  }

  function start() {
    var bron = document.querySelector('script[data-frankly-ingr-lijst]');
    if (!bron) return;
    var lijst;
    try {
      lijst = JSON.parse(bron.textContent);
    } catch (err) {
      // Zonder leesbare lijst blijft de alinea van het etiket staan.
      return;
    }
    var zweef = window.matchMedia('(hover: hover) and (pointer: fine)');
    var nr = 0;
    Array.prototype.forEach.call(document.querySelectorAll('[data-frankly-ingr] p'), function (alinea) {
      var stoffen = lees(alinea, lijst);
      if (stoffen) bouw(alinea, stoffen, lijst, zweef, ++nr);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
